<div class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
       <!-- Chọn option nền cho frame blank -->
       <app-background-image-config [showImageConfig]="false"
       [elementChoosing]="objectChoosing"
       [config]="config"
       [class]="class"
       [backgroundClass]="class['frame-reply-comment']"
       [backgroundConfig]="config['frame-reply-comment']"
       [isBlock]="false"
       [id_object]="objectChoosing._id"
       [device]="device"
     >
     </app-background-image-config>
    </div>
  </ng-container>


  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li
        nz-submenu
        nzTitle="{{'thong_so_co_ban' | translate}}"
        [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Chọn option nền cho frame blank -->
          <app-background-image-config [showImageConfig]="false"
            [elementChoosing]="objectChoosing"
            [config]="config"
            [class]="class"
            [backgroundClass]="class['frame-reply-comment']"
            [backgroundConfig]="config['frame-reply-comment']"
            [isBlock]="false"
            [id_object]="objectChoosing._id"
            [device]="device"
          >
          </app-background-image-config>
        </div>
      </li>
      
      <!-- Cấu hình đường viền chung -->
      <li
        nz-submenu
        nzTitle="{{'duong_vien_chung' | translate}}"
        [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <app-borders-config
          [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [borderClass]="class['frame-reply-comment']"
          [id_object]="objectChoosing._id"
        >
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li
        nz-submenu
        nzTitle="{{'do_bong' | translate}}"
        [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')"
      >
        <!-- Đổ bóng -->
        <app-shadow-config
          [device]="device"
          [config]="config"
          [class]="class"
          [shadowClass]="class['frame-reply-comment']"
          [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing"
        >
        </app-shadow-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [elementChoosing]="objectChoosing"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['frame-reply-comment']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
      <!-- Bo tròn -->
    </div>
  </div>
</div>
